module.exports = __webpack_public_path__ + "img/marta.7194bb04.jpg";